import { render, staticRenderFns } from "./RappersModal.vue?vue&type=template&id=62a5493a&lang=pug&"
import script from "./RappersModal.vue?vue&type=script&lang=js&"
export * from "./RappersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports